const preventImageTheftEvent = (e) => {
  e.preventDefault()
}

export const preventImageTheftProps = {
  onContextMenu: preventImageTheftEvent,
  onDragStart: preventImageTheftEvent,
  onDrop: preventImageTheftEvent,
}
